import script from "./Heading.vue?vue&type=script&setup=true&lang=js"
export * from "./Heading.vue?vue&type=script&setup=true&lang=js"

import "./Heading.vue?vue&type=style&index=0&id=6f9c29dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f9c29dc"]])

export default __exports__